import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import { SettingsProvider } from './context/SettingsContext';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import './styles/global.css';

import HomePage       from './pages/public/HomePage';
import ShopPage       from './pages/public/ShopPage';
import ProductPage    from './pages/public/ProductPage';
import AboutPage      from './pages/public/AboutPage';
import TechRepairPage from './pages/public/TechRepairPage';
import SellPage       from './pages/public/SellPage';
import ContactPage    from './pages/public/ContactPage';
import CartPage       from './pages/public/CartPage';
import CheckoutPage   from './pages/public/CheckoutPage';
import LoginPage      from './pages/public/LoginPage';
import AccountPage    from './pages/public/AccountPage';
import InquiryThreadPage from './pages/public/InquiryThreadPage';
import AdminLogin     from './pages/admin/AdminLogin';
import AdminShell     from './pages/admin/AdminShell';
const PrivacyPage  = () => <div className="container" style={{ padding: '60px 20px' }}><h2 style={{marginBottom:16}}>Privacy Policy</h2><p style={{color:'#666'}}>Full policy coming soon.</p></div>;
const TermsPage    = () => <div className="container" style={{ padding: '60px 20px' }}><h2 style={{marginBottom:16}}>Terms of Service</h2><p style={{color:'#666'}}>Full terms coming soon.</p></div>;
const NotFound     = () => <div className="container" style={{ padding: '80px 20px', textAlign: 'center' }}><div style={{fontSize:64}}>🔍</div><h2 style={{marginTop:16}}>Page Not Found</h2></div>;

function PublicLayout({ children }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar />
      <main style={{ flex: 1 }}>{children}</main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <SettingsProvider>
      <CartProvider>
        <AuthProvider>
          <Routes>
            <Route path="/admin/login"  element={<AdminLogin />} />
            <Route path="/admin/*"       element={<AdminShell />} />
            <Route path="/*" element={
              <PublicLayout>
                <Routes>
                  <Route path="/"                  element={<HomePage />} />
                  <Route path="/shop"              element={<ShopPage />} />
                  <Route path="/shop/:categorySlug" element={<ShopPage />} />
                  <Route path="/product/:uuid"     element={<ProductPage />} />
                  <Route path="/about"             element={<AboutPage />} />
                  <Route path="/tech-repair"       element={<TechRepairPage />} />
                  <Route path="/sell"              element={<SellPage />} />
                  <Route path="/contact"           element={<ContactPage />} />
                  <Route path="/cart"              element={<CartPage />} />
                  <Route path="/checkout"          element={<CheckoutPage />} />
                  <Route path="/login"             element={<LoginPage />} />
                  <Route path="/register"          element={<LoginPage />} />
                  <Route path="/account"           element={<AccountPage />} />
                  <Route path="/inquiry/:token"    element={<InquiryThreadPage />} />
                  <Route path="/privacy"           element={<PrivacyPage />} />
                  <Route path="/terms"             element={<TermsPage />} />
                  <Route path="*"                  element={<NotFound />} />
                </Routes>
              </PublicLayout>
            } />
          </Routes>
        </AuthProvider>
      </CartProvider>
      </SettingsProvider>
    </BrowserRouter>
  );
}
